(() => {
  'use strict';
  const cards=[...document.querySelectorAll('[data-family]')];
  const filterButtons=[...document.querySelectorAll('[data-filter]')];
  function filter(value){
    if(!['all','bulk','crochet'].includes(value))return;
    cards.forEach(card=>{card.hidden=value!=='all'&&card.dataset.family!==value;});
    filterButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===value)));
    const count=cards.filter(card=>!card.hidden).length;
    if(document.querySelector('[data-filter-status]'))document.querySelector('[data-filter-status]').textContent=`Showing ${count} ${value==='all'?'products':value+' products'}.`;
  }
  filterButtons.forEach(button=>button.addEventListener('click',()=>filter(button.dataset.filter)));
  const desktopNav=document.querySelector('[data-main-nav]');
  document.querySelector('[data-mobile-nav]').innerHTML=desktopNav.innerHTML;
  desktopNav.querySelectorAll('details').forEach(item=>item.addEventListener('toggle',()=>{
    if(item.open)desktopNav.querySelectorAll('details').forEach(other=>{if(other!==item)other.open=false;});
  }));
  document.addEventListener('click',event=>{if(!desktopNav.contains(event.target))desktopNav.querySelectorAll('details').forEach(item=>{item.open=false;});});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')desktopNav.querySelectorAll('details').forEach(item=>{item.open=false;});});
  for(const kind of ['menu','search']){
    const dialog=document.querySelector(`[data-${kind}-dialog]`),opener=document.querySelector(`[data-open-${kind}]`),closer=document.querySelector(`[data-close-${kind}]`);
    let previousOverflow='';
    opener.addEventListener('click',()=>{previousOverflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';if(kind==='search')dialog.querySelector('input').focus();});
    closer.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;opener.focus({preventScroll:true});});
    dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  }
})();
